import { format } from 'date-fns';
import { Docket, IntegrationApps, OrderTypeCode } from '@oolio-group/domain';
import { table, TableUserConfig } from 'table';

export const isOnlineOrder = (docket: Docket) => {
  // only apply for few integration app: #5678
  return [
    IntegrationApps.OOLIO_STORE,
    IntegrationApps.DELIVERECT,
    IntegrationApps.DOSHII,
    IntegrationApps.OOM,
  ].includes(docket?.integrationInfo?.app as IntegrationApps);
};

export const getOnlineOrderType = (
  docket: Docket,
  tableConfig: TableUserConfig,
  showCustomerName: boolean,
): string => {
  const orderTypeName = docket.orderType?.name?.toLocaleUpperCase();

  // For catering orders, include the fulfilment type
  let displayOrderType = orderTypeName;
  if (docket?.orderType?.code === OrderTypeCode.CATERING) {
    const fulfilmentType = docket.fulfilmentDetails?.catering?.type;
    const fulfilmentDisplay =
      fulfilmentType === OrderTypeCode.DELIVERY ? 'DELIVERY' : 'PICKUP';
    displayOrderType = `${orderTypeName} ${fulfilmentDisplay}`;
  }

  let orderReceiver = '';
  if (orderTypeName == 'DINE IN' && docket?.table?.name) {
    orderReceiver = `Table ${docket?.table?.name}`;
  }
  // removing customer name on title as it is repeating
  // else if (showCustomerName && docket?.customer?.name) {
  //   orderReceiver = docket.customer?.name;
  // }
  else {
    orderReceiver =
      docket.integrationInfo?.channelOrderDisplayId || docket.orderNumber;
  }
  return table([[displayOrderType, orderReceiver]], tableConfig);
};

export const getPickupTime = (docket: Docket): string => {
  const pickUpTime = docket?.dueAt || docket.requiredAt || docket.createdAt;
  return pickUpTime ? format(pickUpTime, 'dd-MM-yyyy hh:mm aa') : '';
};
export const getOnlineOrderDetail = (
  docket: Docket,
  tableConfig: TableUserConfig,
): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const tableData: any[] = [];
  // Order Number
  tableData.push(['Order No:', docket.orderNumber]);

  //  Due At — dueAt is only set for explicitly scheduled orders; requiredAt always
  //  defaults to creation time so is not a safe signal for scheduling intent
  if (docket.dueAt) {
    tableData.push(['Due At:', getPickupTime(docket)]);
  }

  return table(tableData, tableConfig);
};
